module.exports = __webpack_public_path__ + "static/albuquerque-1c811cfe9a92a49f5b6e03882f6e862a.png";